import React from 'react'
import {AttributeModel} from '../model/AttributeModel'
import {ComplexAttribute} from './ComplexAttribute'

export const ClassificationLinkAttribute = ({attribute}: { attribute: AttributeModel }) => {
    return <ComplexAttribute attribute={attribute}>
        <div className="display-set-definition"
             data-testid="test-details-definition-name"
             id={attribute.value?.classificationNode?.id}>
            <span className="definition-name">{attribute.value?.classificationNode?.code}</span>
            <div className="display-set-attributes">
                <span className="item-attribute-value" data-testid="test-details-simple-attribute-value" key={attribute.id}>{attribute?.value?.classificationNode?.label}</span>
            </div>
        </div>
    </ComplexAttribute>

}